module.exports = __webpack_public_path__ + "src/img/loofah/loofahleaf.png?c40118e4c04a59afbd168e7e3d81ce11";


//////////////////
// WEBPACK FOOTER
// ./src/img/loofah/loofahleaf.png
// module id = 194
// module chunks = 0